import { Center, Image, Text, VStack } from '@chakra-ui/react'
import { getPublicPath } from 'utils/routes'

const ExpiredLicense = () => {
  return (
    <Center mt="25vmin">
      <VStack>
        <Image
          objectFit="contain"
          h="100%"
          w="80px"
          src={getPublicPath('/faros-logo.svg')}
        />
        <Text>
          Your trial has expired. Please contact us to renew the license.
        </Text>
      </VStack>
    </Center>
  )
}

export default ExpiredLicense
